import React, { PureComponent } from 'react';
import './styles.css';

class Loading extends PureComponent {
  constructor(props) {
    super(props);
    const { delay } = this.props;
    this.state = { show: !(delay && delay > 0) };
  }

  componentDidMount() {
    const { delay } = this.props;
    if (delay) {
      this.timer = setTimeout(() => {
        this.setState(() => ({ show: true }));
      }, delay);
    }
  }

  componentWillUnmount() {
    this.timer = clearTimeout(this.timer);
  }

  render() {
    const { show } = this.state;
    return show ? (
      <section style={{ padding: '2rem' }} data-testid="loader">
        <i className="mnd-loader" />
      </section>
    ) : null;
  }
}

export default Loading;
